import videojs from 'video.js';

export const BannerBehavior = Object.freeze({
    Disabled: 'Disabled',
    AutoHide: 'AutoHide',
    Static: 'Static'
});

const AUTO_HIDE_CLASS = 'mediasite-player__banner-img--auto-hide';

let localize;

export default class BannerLink extends videojs.getComponent('ClickableComponent') {
    constructor(player, options) {
        localize = player.localize?.bind(player);

        super(player, options);

        player.ready(() => {
            this.controlText(localize("Video banner"));
        });
    }

    createEl(tag, props = {}, attributes = {}) {
        tag = 'a';
        props = Object.assign({
            className: `mediasite-player__banner-img ${AUTO_HIDE_CLASS}`
        });
        attributes = Object.assign({
            target: '_blank',
            alt: localize("Video banner")
        });

        return super.createEl.call(this, tag, props, attributes);
    }

    get behavior() {
        return this.hasClass(AUTO_HIDE_CLASS) ? BannerBehavior.AutoHide : BannerBehavior.Static;
    }

    set behavior(behavior) {
        if (behavior === BannerBehavior.AutoHide) {
            this.addClass(AUTO_HIDE_CLASS);
        }
        else if (behavior === BannerBehavior.Static) {
            this.removeClass(AUTO_HIDE_CLASS);
        }
        else if (behavior === BannerBehavior.Disabled) {
        }
        else {
            throw new Error(`Invalid banner image behavior "${behavior}".`);
        }
    }

}
